import type { TypeCmsSlug, TypeLang } from '@/schema'
import { LANGUAGES } from './constants'
import { getStoreUrlByLocale } from './project'

const HREFLANG_TARGETS = [
	{ hreflang: 'es-ES', locale: 'es-ES', lang: 'es' },
	{ hreflang: 'fr-FR', locale: 'fr-FR', lang: 'fr' },
	{ hreflang: 'de-DE', locale: 'de-DE', lang: 'de' },
	{ hreflang: 'pt-PT', locale: 'pt-PT', lang: 'pt' },
	{ hreflang: 'en-GB', locale: 'en-GB', lang: 'en' },
	{ hreflang: 'en', locale: 'en-EU', lang: 'en' },
	{ hreflang: 'x-default', locale: 'en-EU', lang: 'en' },
] as const

type HreflangCode = (typeof HREFLANG_TARGETS)[number]['hreflang']

type Alternates = {
	canonical: string
	languages: Partial<Record<HreflangCode, string>>
}

function pathnameFromSlug (prefix: string, slug: string) {
	const cleanPrefix = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix
	const cleanSlug = slug.replace(/^\/+/, '')
	return `${cleanPrefix}/${cleanSlug}`
}

function pathnameByLang ({ pathname, prefix, slug }: { pathname: string, prefix?: string, slug?: TypeCmsSlug | null }) {
	const paths: Partial<Record<TypeLang, string>> = {}

	if (!slug) {
		for (const lang of LANGUAGES) paths[lang] = pathname
		return paths
	}

	if (!prefix) return paths

	for (const lang of LANGUAGES) {
		const value = slug[lang]
		if (!value) continue
		paths[lang] = pathnameFromSlug(prefix, value)
	}

	return paths
}

export function getAlternates ({ pathname, prefix, slug }: { pathname: string, prefix?: string, slug?: TypeCmsSlug | null }): Alternates {
	const paths = pathnameByLang({ pathname, prefix, slug })
	const languages: Alternates['languages'] = {}

	for (const target of HREFLANG_TARGETS) {
		const path = paths[target.lang]
		if (!path) continue
		const host = getStoreUrlByLocale(target.locale, true)
		if (!host) continue
		languages[target.hreflang] = path === '/' ? `https://${host}` : `https://${host}${path}`
	}

	return {
		canonical: pathname,
		languages,
	}
}
